import styled from 'styled-components';
import StyledBtn from "../../styles/StyledBtn";

export const HeaderWrapper = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  
  padding: 0 40px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  
  background-color: white;
`
export const ProfileImg = styled.img`
  width: 40px;
  height: 40px;
  
  border-radius: 50%;
  
  cursor: pointer;
`
